import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
const StocksAlertsTable = ({
  stockData = [],
  loading,
  handleDelete,
  handleUpdate,
}) => {
  const [editRowId, setEditRowId] = useState(null);
  const [editValues, setEditValues] = useState({});

  const handleEditClick = (row) => {
    setEditRowId(row.id);
    setEditValues({
      recommendation: row.recommendation,
      is_active: row.is_active,
    });
  };

  const handleSave = (row) => {
    handleUpdate(row, editValues);
    setEditRowId(null);
    setEditValues({});
  };
  const headCells = [
    "ID",
    "Stock Name",
    "Recommendation",
    "Date",
    "Status",
    "Actions",
  ];

  return (
    <Box>
      {loading ? (
        <Box display="flex" justifyContent="center" p={5}>
          <CircularProgress sx={{ color: "#016551" }} />
        </Box>
      ) : (
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            overflowY: "auto",
            maxHeight: "65vh",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
          }}
        > 
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {headCells.map((label) => (
                  <TableCell
                    key={label}
                    sx={{
                      fontWeight: 700,
                      fontSize: "13px",
                      color: "#fff",
                      background: "#04343a",
                      borderBottom: "none",
                      padding: "12px 16px",
                    }}
                  >
                    {label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {stockData.length > 0 ? (
                stockData.map((row) => {
                  const isEditing = editRowId === row.id;

                  return (
                    <TableRow
                      key={row.id}
                      sx={{ "&:hover": { background: "#f0faf5" } }}
                    >
                      <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>
                        {row.id}
                      </TableCell>
                      <TableCell>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: "#016551",
                            fontSize: "14px",
                          }}
                        >
                          {row.stock_name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            select
                            size="small"
                            value={editValues.recommendation}
                            onChange={(e) =>
                              setEditValues((prev) => ({
                                ...prev,
                                recommendation: e.target.value,
                              }))
                            }
                            variant="standard"
                          >
                            <MenuItem value="Green">Green</MenuItem>
                            <MenuItem value="Red">Red</MenuItem>
                          </TextField>
                        ) : (
                          <Chip
                            label={row.recommendation}
                            size="small"
                            sx={{
                              background:
                                row.recommendation === "Green"
                                  ? "#e8f5e9"
                                  : "#fdecea",
                              color:
                                row.recommendation === "Green"
                                  ? "#2e7d32"
                                  : "#c62828",
                              fontWeight: 600,
                              fontSize: "12px",
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>
                        {new Date(row.date).toLocaleString()}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <TextField
                            select
                            size="small"
                            value={editValues.is_active ? "Active" : "Inactive"}
                            onChange={(e) =>
                              setEditValues((prev) => ({
                                ...prev,
                                is_active: e.target.value === "Active",
                              }))
                            }
                            variant="standard"
                          >
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                          </TextField>
                        ) : (
                          <Chip
                            label={row.is_active ? "Active" : "Inactive"}
                            size="small"
                            sx={{
                              background: row.is_active ? "#e8f5e9" : "#f1f5f9",
                              color: row.is_active ? "#016551" : "#64748b",
                              fontWeight: 600,
                              fontSize: "12px",
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell>
                        {isEditing ? (
                          <IconButton
                            onClick={() => handleSave(row)}
                            sx={{ color: "#016551" }}
                          >
                            <SaveIcon />
                          </IconButton>
                        ) : (
                          <IconButton
                            onClick={() => handleEditClick(row)}
                            sx={{ color: "#04343a" }}
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                        <IconButton
                          onClick={() => handleDelete(row)}
                          sx={{ color: "#e53935" }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    sx={{ py: 5, color: "#94a3b8" }}
                  >
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default StocksAlertsTable;
